import { ButtonLink } from '@src/common/components/button/ButtonLink';
import { css } from '@src/common/styles/Styles';

export const GlobalErrorBoundary = () => {
  return (
    <main className={container}>
      <h1>Oups, an error occured</h1>

      <ButtonLink to="/">Return Home</ButtonLink>
    </main>
  );
};

const container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  gap: 40px;
`;
